import {createAction, props} from "@ngrx/store";
import {
  DeliveryDetails,
  IETADetails,
  IFeatureVisbilityProperties,
  IOrderStatus,
  IOrderTrackByIdResponse,
  IRatingDetails,
  IRatingPayload,
  TrackDetails
} from "../../models/DeliveryDetails";
import {LatLng} from "leaflet";
import {CarrierData, StatusData, TrackData} from "src/app/models/custom.types";
import {IDeliveryProofPayload} from "src/app/components/delivery-proof/delivery-proof.component";
import { IOrderConfig, OrdersById } from "../../../app/components/calibrate-data/calibrate-data.component";

export const setDeliverTokenId = createAction(
  "[Home] set delivery token id",
  props<{ data: string }>()
)

export const setAgentLatLng = createAction(
  "[Home] set Agent LatLng",
  props<{ data: LatLng }>()
)

export const setTrackData = createAction(
  "[Home] set Track Data",
  props<{ data: TrackData }>()
)
export const setStatusData = createAction(
  "[Home] set Status Data",
  props<{ data: StatusData }>()
)
export const loadDeliveryDetails = createAction(
  "[Home] load delivery details",
)
export const loadDeliveryDetailsSuccess = createAction(
  "[Home] load delivery details Success",
  props<{ deliveryDetails: DeliveryDetails }>()
)
export const loadTrackDetails = createAction(
  "[Home] load Track details",
)
export const loadTrackDetailsSuccess = createAction(
  "[Home] load Track Details Success",
  props<{ data: TrackDetails[] }>()
)
export const loadEta = createAction(
  "[Home] load ETA",
)
export const loadEtaSuccess = createAction(
  "[Home] load ETA Success",
  props<{ data: IETADetails }>()
)
export const success = createAction(
  "[Home] on success",
)
export const failure = createAction(
  "[Home] on failure",
  props<{ error: string }>()
)
export const loadDeliveryDataFailure = createAction(
  "[Home] load delivery data failure",
  props<{ error: unknown }>()
)

export const loadRatings = createAction(
  "[HOME] load ratings"
)

export const loadRatingsSuccess = createAction(
  "[Home] load ratings Success",
  props<{ data: IRatingDetails[] }>()
)

export const postRatings = createAction(
  "[Home] post raings",
  props<{ payload: IRatingPayload[] }>()
)

export const postRatingSuccess = createAction(
  "[Home] post rating Success",
  props<{ data: IRatingPayload[] }>()
)


export const deliveryProof = createAction(
  "[Home] dilvery proof",
  props<{ payload: IDeliveryProofPayload, deliveryStatus?: string, deliveryTokenId?: string }>()
)

export const deliveryProofSuccess = createAction(
  "[Home]dilvery proof Success",
  props<{ msg: string }>()
)

export const loadOrderStatus = createAction(
  "[Home] get order status ",
)

export const loadOrderStatusSuccess = createAction(
  "[Home] get order status success",
  props<{ data: IOrderStatus }>()
)

export const loadCarrierData = createAction(
  "[Home] load live temperature",
)

export const loadCarrierDataSuccess = createAction(
  "[Home] load live temperature success",
  props<{ data: CarrierData }>()
)

export const setDeliveryAcknowledgeViewStatus = createAction(
  "[Home] set deliver acknowledge view status",
  props<{ status: string }>()
)

export const loadDeliveryDetailsAndFeatureVisibilitySuccess = createAction(
  "[Home] load delivery details and feature visibility success",
  props<{ deliveryDetails: DeliveryDetails, featureVisibility : IFeatureVisbilityProperties }>()
)
export const isWarehosueOrderId = createAction(
  "[Warehouse OrderID] is ware house order Id Boolean",
  props<{orderId:string}>()
)

export const isOrderInParamsAction = createAction(
  "[Home] is Order Id In Params",
  props<{ value:string }>()
)

export const setOrderIdForTimeline = createAction(
  "[Home] set order id for timeline",
  props<{ value:string }>()
)

export const setDocketId = createAction(
  "[Home] set docket id",
  props<{ value:string }>()
)

export const setOrderStatusForTimeline = createAction(
  "[Home] set order status for timeline",
  props<{ value: string }>()
)

export const loadOrderTrackById = createAction(
  "[Home] load order track by order id"
)

export const loadOrderTrackByIdSuccess = createAction(
  "[Home] load order track by order id success",
  props<{ data: IOrderTrackByIdResponse }>()
)

export const getOrderTrackInfoConfig = createAction(
  "[CALIBRATE] get order track info config"
)
export const getOrderTrackInfoConfigSucess = createAction(
  "[CALIBRATE] get order track info config success",
  props<{ data:IOrderConfig}>()
)
export const getOrderDetailsData = createAction(
  "[CALIBRATE] get order track details"
)
export const getOrderDetailsDataSucess = createAction(
  "[CALIBRATE] get order track details success",
  props<{ res:{data:{ordersById:OrdersById}}}>()
)

export const setAccountLogoForOrderId = createAction(
  "[Home] set Account Logo For Order Id",
  props<{ orderId:string,accountId:string }>()
)

export const setAccountLogoForOrderIdSuccess = createAction(
  "[Home] set Account Logo For Order Id Success",
  props<{ logo:any }>()
)

export const setSelfAccountLogo = createAction(
  "[Home] set self Account Logo "
)